import { getSelfServiceRoadsideAssistancePageUrl } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';

export const UpgradeRoadsideService = {
  /**
   * Get roadside assistance URL
   * @returns
   */
  getSelfServiceRoadsideAssistancePage(): Promise<string> {
    return _http.HttpGet(`${getSelfServiceRoadsideAssistancePageUrl}`);
  },
} as const;
